var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"fct-input",attrs:{"disabled":_vm.disabled,"name":_vm.name || _vm.label,"id":_vm.id || 'input-' + _vm.label,"type":_vm.type},domProps:{"value":_vm.presentedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }